import { Observable, of } from 'rxjs';

import { ResearchType } from '@empathy/global/data';

import { ProjectsAdminService } from '../../services/projects-admin.service';

export const ResearchAnalytics: Record<ResearchType, (service: ProjectsAdminService,  projectId: string, methodId: string) => Observable<any>> = {
  [ResearchType.AIInterview]: (service: ProjectsAdminService,  projectId: string, methodId: string) => service.getAiResearchAnalytics(projectId, methodId),
  [ResearchType.DiscussionForum]: (_service: ProjectsAdminService,  _projectId: string, _methodId: string) => of({}),
  [ResearchType.Survey]: (service: ProjectsAdminService,  projectId: string, methodId: string) => service.getSurveyResearchAnalytics(projectId, methodId),
  [ResearchType.FoodDiary]: () => of({}),
  [ResearchType.ExternalSurvey]: (service: ProjectsAdminService,  projectId: string, methodId: string) => service.getSurveyResearchAnalytics(projectId, methodId)
};
